import {ClassicType} from "../../shared/models/ClassicType";
import {Categorie} from "../../Progetti/Models/Categorie";
import {TranslateObj} from "../../shared/models/translatedesc";
import {Azienda} from "../../Admin/models/Azienda";

export class Materiale {
  nome?: string;
  prezzo?: string;
  enabled?: boolean;
  codice?: string;
  tipo?: number;
  um_id?: number;
  categorie?: number[];
  id?: string;
  umObject: ClassicType;
  categorieObject: Categorie[];
  modifica?: boolean;
  magazzino?: number;
  scortaMin?: number;
  codice_produttore?: number;
  partiEcObject: any[];
  partiEc: number[];
  transaltedobjects?: TranslateObj [];
  traduzioni?: TranslateObj [];
  acquistati?: number;
  ordinati?: number;
  fornitoreObject?: Azienda;
  fornitore?:number;
  quantita?: number;
  isSelected?: boolean;
  consegnati?: any;
  UrlImmagine?: string;
  immagine?:any;
  id_immagine?: any;

  get label(): string {
    return this.nome;
  }
  set label(value: string) {
    this.nome = value;
  }

}
